import { render, staticRenderFns } from "./SplaLicenceModal.vue?vue&type=template&id=06ab3820&"
import script from "./SplaLicenceModal.vue?vue&type=script&lang=js&"
export * from "./SplaLicenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports